import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useEffect, useState } from "react";
import { ColorSquare, Icon, MultiSelect } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
//#region src/modules/Events/shared/SearchFilterEventMultiSelect.tsx
var LIMIT = 25;
function SearchFilterEventMultiSelect({ focused, label = "Events", onChange, onClearSelection, onClick, value }) {
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const { rpcService } = useRPCContext();
	useEffect(() => {
		setLoading(true);
		rpcService.Events.GetEventsList.v1.call({ pagination: { limit: LIMIT } }).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.events);
		}).finally(() => setLoading(false));
	}, []);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Events.GetEventsList.v1.call({
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.events]);
		});
		else if (opts.text) rpcService.Events.GetEventsList.v1.call({
			pagination: { limit: LIMIT },
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.events);
		});
	};
	return /* @__PURE__ */ jsx("div", {
		className: "bg-surface-strong p-xs",
		children: /* @__PURE__ */ jsxs("div", {
			className: "space-y-sm w-full font-bold",
			onClick,
			children: [/* @__PURE__ */ jsxs("span", {
				className: "flex w-full justify-between hover:cursor-pointer",
				children: [/* @__PURE__ */ jsx("span", { children: label }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
			}), focused && /* @__PURE__ */ jsx("div", {
				onClick: (e) => e.stopPropagation(),
				children: /* @__PURE__ */ jsx(MultiSelect, {
					disabled: loading,
					disableSelectAll: true,
					loading,
					onChangeValue: onChange,
					onClearSelection,
					loadOptions: handleLoadOptions,
					optionLabelExtractor: (option) => option.title,
					options,
					optionValueExtractor: (option) => option.id || "",
					placeholder: "Location",
					renderOption: (option) => /* @__PURE__ */ jsx("div", {
						className: "gap-x-xxs pb-xs inline-flex items-center justify-center",
						children: /* @__PURE__ */ jsxs("div", {
							className: "flex flex-col",
							children: [option.idLabel && /* @__PURE__ */ jsx("div", {
								className: "text-color-neutral text-sm font-bold",
								children: option.idLabel
							}), /* @__PURE__ */ jsxs("div", {
								className: "flex items-center justify-between",
								children: [/* @__PURE__ */ jsx(ColorSquare, {
									color: option.eventType.color,
									preserveSpace: true,
									marginRight: true,
									size: "sm"
								}), /* @__PURE__ */ jsx("div", {
									className: "text-color-strong",
									children: option.title
								})]
							})]
						})
					}),
					totalOptions,
					value: value || []
				})
			})]
		})
	});
}
//#endregion
export { SearchFilterEventMultiSelect };

//# sourceMappingURL=SearchFilterEventMultiSelect.js.map